import { db, auth } from '@/plugins/firebase';
import firebase from 'firebase';
import algoliasearch from 'algoliasearch';
import 'firebase/app';
import { bus } from '@/main';
import { createNullCache } from '@algolia/cache-common';
import axios from 'axios';
//Register algolia API Keys
const algolia = algoliasearch(
  'Z4FFQXGI6X',
  '93fd370a4e2cb299fbec34c6afb8ba9b',
  {
    // Caches responses from Algolia
    responsesCache: createNullCache(),

    // Caches Promises with the same request payload
    requestsCache: createNullCache(),
  },
);
const limit = 100;
var chatFeedItems = [];
export async function getFeedByRegion(
  { commit },
  { mutation, region, page = 0, didSwitchRegion = false },
) {
  return new Promise((resolve, reject) => {
    if (didSwitchRegion) {
      chatFeedItems = [];
    }
    return algolia
      .initIndex('post')
      .search('', {
        filters: 'type:conversation AND state:active AND isMarker:false',
        //aroundLatLng: `${44.947989}, ${-93.036613}`,
        aroundLatLng: `${region.latitude}, ${region.longitude}`,
        aroundRadius: 16 * 1000,
        hitsPerPage: limit,
        page,
      })
      .then(({ hits }) => {
        console.log(hits[0]);
        hits.forEach((doc) => {
          chatFeedItems.push(doc);
        });

        commit(mutation, chatFeedItems);
        resolve();
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export async function getComments({ commit }, { postId }) {
  commit('updateComments', []);
  return new Promise((resolve, reject) => {
    let fetchCommentsForPost = firebase
      .functions()
      .httpsCallable('fetchCommentsForPost');

    console.log(postId);

    fetchCommentsForPost({ postId }).then((result) => {
      // Read result of the Cloud Function.
      var sanitizedMessage = result.data;
      console.log(sanitizedMessage);
      commit('updateComments', sanitizedMessage.comments);
      resolve();
    });
  });
}

export async function postComment({ commit }, { postId, content }) {
  return new Promise((resolve, reject) => {
    let addCommentToPost = firebase
      .functions()
      .httpsCallable('addCommentToPost');

    const comment = {
      content,
      state: 'active',
      score: Number(0),
      createdBy: auth.currentUser.uid,
      adminUser: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
    };

    console.log(comment);

    addCommentToPost({ postId, comment }).then((result) => {
      // Read result of the Cloud Function.
      var sanitizedMessage = result.data;
      console.log(sanitizedMessage);

      resolve();
    });
  });
}
